'use strict';

import bookingMaskService from './bookingMaskService';
import {trackEvent} from '@farmnet/tag-manager';

angular
  .module('cfn')
  .controller('bookingMaskController', bookingMaskController);

bookingMaskController.$inject = [
  '$scope',
  '$rootScope',
  '$location',
  '$dialog',
  '$http',
  '$route',
  '$q',
  '$timeout',
  '$window',
  '$routeParams',
  'dateFilter',
  'BookingOperations',
  'bookingService',
  'bookingRules',
  'bookingActivitiesService',
  'bookingMaskArguments',
  'i18nFilter',
  'CfnDialogService',
  'fendtVarioDocService',
  'fendtVarioDocAlerts',
  'timeZoneHackService',
  'bookingNavigationService',
  'bookingAttachmentService',
  'bookingMaskService',
  'cultureSearch.service',
  'navigationService',
  '$log'
];

function bookingMaskController(
  $scope,
  $rootScope,
  $location,
  $dialog,
  $http,
  $route,
  $q,
  $timeout,
  $window,
  $routeParams,
  dateFilter,
  BookingOperations,
  bookingService,
  bookingRules,
  bookingActivitiesService,
  bookingMaskArguments,
  i18nFilter,
  CfnDialogService,
  fendtVarioDocService,
  fendtVarioDocAlerts,
  timeZoneHackService,
  bookingNavigationService,
  bookingAttachmentService,
  bookingMaskService,
  cultureSearchService,
  navigationService,
  $log
) {

  // will be overwritten later
  $scope.fnMessage = {
    show: false,
    key: '', // will be filled in later when we know the user country and activity type
    type: ''  // will be filled in later when we know the user country and activity type
  };

  $scope.details = {
    allDay: true,
    id: null
  };

  $scope.indications = [];
  $scope.item = null;
  $scope.model = null;
  $scope.selectedCulture = null;

  let controller = this;
  let isPlanning = false;

  function handleError(response) {
    let result = response.data;
    $log.error('got error', result);
    $rootScope.alertController.handleConnectionError(
      result,
      i18nFilter(
        'fe.booking.operation.missing',
        'Die Buchung wurde nicht gefunden'
      )
    );
    gotoList();
  }

  controller.section = 'FIELD';

  // for bookingMask.html-ng-repeat.
  $scope.elements = bookingRules.elementsArray(controller.section, $scope.details.icon);
  let loaded = _.object(
    _.map($scope.elements, element => {
      let lazyLoad =
        (element.hasOwnProperty('lazyLoad') && element.lazyLoad) || false;
      return [element.name, !lazyLoad];
    })
  );

  $scope.finishedLoading = element => {
    return loaded[element];
  };

  function gotoList() {
    $location.path('/booking/' + controller.section.toLowerCase() + '/list');
  }

  function markSent(bookingId) {
    let url = '/365FarmNet/mod/booking-service/booking/operation/rest/v1.0/markSent';
    return $http.post(url, [bookingId]);
  }

  controller.delete = () => {
    CfnDialogService.confirm(() => {
      app.startLoading();
      BookingOperations.delete({ id: $scope.details.id }, result => {
        app.finishLoading();
        if (result.success) {
          gotoList();
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.common.message.successfullyDeleted',
              'erfolgreich gelöscht'
            ),
            'success'
          );
        } else {
          $rootScope.handleMsgContext(result.messagingContext);
        }
      });
    });
  };

  controller.cancel = () => {
    let activity = $scope.details.activities;
    if (
      !$scope.dataForm.$dirty ||
      window.confirm(
        i18n(
          'fe.message.confirm.unsavedModifications',
          'Ungespeicherte Änderungen gehen verloren. Sind Sie sicher?'
        )
      )
    ) {
      controller.clear();
      if (activity === 'SOILSAMPLE') {
        $location.path('/booking/soilsample');
        return;
      }
      $window.location.href = '#/booking/field';
    }
  };

  controller.btnState = {
    plannable: false,
    editButton: false,
    bookable: false,
    saveable: false,
    templateable: false,
    deleteable: false,
    prebookable: false,
    stornoable: false
  };

  controller.fendtVarioDocState = {
    validMachinesCount: 0,
    sendData: false
  };

  $scope.$watchCollection('[details.state, details.endDate, details.startDate]', (newCollection, oldCollection) => {
      if (!$scope.details) {
        controller.btnState = {
          plannable: false,
          editButton: false,
          bookable: false,
          saveable: false,
          templateable: false,
          prebookable: false,
          deleteable: false,
          stornoable: false,
          template: false
        };
      } else {
        let isNew = !$scope.details.id;
        let isBooked = $scope.details.state === 'BOOKED';
        let isPreliminary = $scope.details.state === 'PRELIMINARY';
        let isPlanning = $scope.details.state === 'INPLANNING';
        let isTemplate = controller.isTemplate();
        let isSoilSample = controller.section === 'SOILSAMPLE';

        if (!$scope.details.state && !$scope.details.id) $scope.mode = 'SELECT';
        else if (!$scope.id && !controller.isTemplate())
        // Aktivität auswählen
          $scope.mode = 'BOOK';
        // Aktivität buchen
        else $scope.mode = 'EDIT'; // Aktivität bearbeiten

        controller.btnState = {
          plannable: false && !isSoilSample, // zur zeit kann man nicht auf planen drücken !
          editButton: isBooked && !isSoilSample, // editieren geht nur bei gebuchten sachen
          bookable: isPreliminary && !isSoilSample,
          prebookable: isPlanning && !isSoilSample,
          saveable: !isBooked,
          templateable: !isTemplate && !isSoilSample,
          deleteable: !isNew && !isBooked && !isTemplate,
          stornoable: !isNew && isBooked && !isTemplate,
          canCancel: $scope.mode == 'EDIT' || $scope.mode == 'BOOK'
        };

        let isPast = $scope.details.endDate < new Date();
        let isFuture = !isPast;

        // am gleichen tag geht beides
        if (new Date($scope.details.endDate).isSameDay(new Date())) {
          isFuture = true;
        }

        if (new Date($scope.details.startDate).isSameDay(new Date())) {
          isPast = true;
        }

        controller.btnState.editButton = false;
        controller.btnState.bookable = isPast && $scope.mode === 'BOOK';
        controller.btnState.plannable = isFuture && $scope.mode === 'BOOK' && !isSoilSample;
        controller.btnState.prebookable = isPast && !isBooked && $scope.mode === 'BOOK' && !isSoilSample;
        controller.btnState.saveable = isTemplate;
      }
    }
  );

  controller.isTemplate = () => {
    return $scope.details.state === 'TEMPLATE';
  };

  controller.canSaveTemplate = () => {
    return (
      controller.isTemplate() &&
      bookingRules.hasActiveElements() && // elements required
      $scope.details.templateName
    ); // template-name required
  };

  controller.hasFields = () => {
    return !!(typeof $scope.details.fieldList !== 'undefined' && $scope.details.fieldList.length);
  };

  controller.addDirectToList = (obType, type, list, result, successFunc) => {
    function addToList() {
      let newEle = {};
      newEle[type] = result[obType];
      newEle[type + 'Type'] = firstUpper(obType);

      if (type.toLowerCase() === 'asset' && result[obType].farmedArea) {
        newEle.unit = 'AREAL_HA';
        newEle.amount = result[obType].farmedArea;
      }

      if (type.toLowerCase() === 'resource') {
        newEle.unit = newEle[type].activityUnit;
      }

      if (newEle[type].sowingType) {
        // todo: automatic mapping via generator, ASK ASG !
        newEle.sowingType = newEle[type].sowingType;
      }

      if (type.toLowerCase() === 'supply') {
        newEle.unit = result.unit || newEle[type].activityUnit;
      }

      newEle.amountPerArea = result.amountPerArea || undefined;
      newEle.costsGrossPrice = newEle[type].grossPrice;

      if (successFunc) {
        successFunc(newEle, result[obType]);
      }

      if (bookingRules.elements[obType].onInsert) {
        bookingRules.elements[obType].onInsert(newEle);
      }
    } // addToList

    // if invalid first ask to correct
    if (result[obType].invalid) {
      // FIXME: dependent on obType we have different values for NULL
      if (result[obType].nameString === null || result[obType].nameString === '' || result[obType].nameString === 'null') {
        result[obType].nameString = i18nFilter('fe.booking.' + obType + '.unknown', 'unknown ' + obType);
      }

      CfnDialogService.showAckDialog(
        i18nFilter(
          'fe.booking.gotoCore.title',
          result[obType].nameString +
          ' ist nicht valide und kann nicht hinzugefügt werden',
          result[obType].nameString
        ),
        i18nFilter(
          'fe.booking.gotoCore.message',
          'Möchten sie den Stammdatensatz direkt korrigieren?',
          result[obType].nameString
        ),
        () => {
          // on ok
          addToList();
          controller.goBackToCore(obType, result[obType].id);
        }
      );
    } else {
      addToList();
    }
  };

  // called from (Sub-)elements on ADD-Button (Personen->hinzufügen)
  $scope.addToList = (obType, type, list, successFunc) => {
    return (ob) => {
      $scope.dataForm.$setDirty();
      // call for all group members or call local
      bookingService.enableGroupAdd(obType, ob, (obType, ob) => {
        let url = '/365FarmNet/rest/core/' + obType.toLowerCase() + '/flat/' + ob.id;
        $http.get(url)
          .then(response => {
            let result = response.data;
            controller.addDirectToList(obType, type, list, result, successFunc);
            $rootScope.preventNavigation();
          });
      });
    };
  };

  // sind aktive Elemente geladen?
  $scope.hasElements = () => {
    return bookingRules.isElementActive(controller.section);
  };

  $scope.$watch('details.id', (newValue, oldValue) => {
    if (angular.isUndefined(newValue)) {
      // No Activity selected
      controller.clear();
    }
    if (angular.isString(newValue)) {
      // reload elements in correct order for current selected template
      // $scope.elements = bookingRules.elementsArray(controller.section, $scope.details.icon ? $scope.details.icon : null);
      // load template
      controller.loadById(newValue);
    }
  });

  // Remove section
  controller.removeFromList = (obType, type, list, ele) => {
    let array = $scope.details[list];
    $.each(array, function(i) {
      if (array[i] == ele) {
        array.splice(i, 1);
        return false;
      }
    });
  };

  controller.endDateChanged = () => {
    controller.endDateLinked = false;
  };

  controller.getStartDateDefault = () => {
    // set startdate to current startdate or the cookie date or a new date
    if ($scope.details && $scope.details.startDate && !$scope.details.template) {
      return $scope.details.startDate;
    } else {
      let startDate = getCookieInt('booking.lastStartDate');
      return startDate ? new Date(startDate) : new Date();
    }
  };

  // clear mask
  controller.clear = () => {
    isPlanning = false;

    // Inform all elements (Field, Seed,...) to clear elements
    angular.forEach(bookingRules.getActiveElements(controller.section), element => {
        if (element.onClear) {
          element.onClear();
        }
      });

    $scope.details = {};

    if ($location.path().indexOf('activity') !== -1) {
      $scope.details.state = 'TEMPLATE';
      $scope.details.templateName = i18nFilter('fe.booking.activity.newName', 'Neue Tätigkeit');
      $scope.details.bookingSection = controller.section;
      $scope.details.products = [{}]; // Prevent culture selection (a row is always required)
    }

    bookingRules.setAllActiveActivities(controller.section); // no activity selected
    $rootScope.allowNavigation();
  };

  controller.isActivityController = () => {
    return $location.path().indexOf('/booking/activity') !== -1;
  };

  // load operation by Id
  controller.loadById = id => {
    app.startLoading();

    bookingAttachmentService.list(id).then(result => {
      let attachments = result.data;

      if (attachments && attachments.length) {
        attachments = attachments.filter(attachment => attachment.type === 'COUNTER');

        if (attachments && attachments.length) {
          $scope.attachments = _.map(attachments, function(att) {
            att.url = bookingAttachmentService.getAttachmentUrl(att.id);
            return att;
          });

          loaded['attachments'] = $scope.attachments.length !== 0;
        } else {
          $scope.attachments = null;
        }
      }
    });

    $scope.details.isLoading = true;

    if (controller.isActivityController()) {
      bookingActivitiesService.load(id).then(response => {
        let result = response.data;

        if (result.id) {
          // only if content existing
          controller.loadByObject(result);
        }

        app.finishLoading();
      }, handleError);
    } else {
      if (bookingActivitiesService.isActivity(id)) {
        bookingActivitiesService.load(id).then(response => {
          let result = response.data;

          if (result.id) {
            // only if content existing
            controller.loadByObject(result);
          }
          app.finishLoading();
        }, handleError);
      } else {
        BookingOperations.load({ id: id }, function(result) {
            if (result.id) {
              // only if content existing
              controller.loadByObject(result);
              // Show validation messages
              $rootScope.handleMsgContext(result.messagingContext);
            }
            app.finishLoading();
          },
          handleError
        );
      }
    }
  };

  function isHarvesting(activityName) {
    return activityName && activityName.includes('HARVESTING');
  }

  function isPreliminary(state) {
    return state && state === 'PRELIMINARY';
  }
  
  function hasHarvestAmountButNoProduct(products) {
    let product = _.first(products);               
    return product && product.amount && product.amount > 0 && !product.harvestProduct;
  }

  function checkHarvestProductForPreliminaryOperation(operation) {
    if (operation 
        && isPreliminary(operation.state)
        && isHarvesting(operation.activityName)
        && hasHarvestAmountButNoProduct(operation.products)) {
      let message = i18nFilter('fe.booking.operation.harvest.noProductButAmount');
      $rootScope.alertController.addTemporaryAlertWithCustomTimer(message, 'info', null, 8000);
    }
  }

  // load operation from object
  controller.loadByObject = result => {
    isPlanning = result.state === 'INPLANNING';
    $scope.cropOnFields = {};

    if (result.extraData) {
      // Convert JSON string to actual JSON object for convenient access
      result.extraData = JSON.parse(result.extraData);
      $scope.details.specialData = result.extraData;
    }
    checkHarvestProductForPreliminaryOperation(result);
    if (result.template) {
      // clear operation ids to be able to save it
      if (!controller.isActivityController()) {
        // Template im Booking-Modus
        $scope.details.id = null;
        $scope.details.state = '';
        $scope.details.startDate = controller.getStartDateDefault();
        $scope.details.allDay = true;
      } else {
        $scope.details.id = result.id;
        $scope.details.state = 'TEMPLATE';
      }
    } else {
      $scope.details.id = result.id;
      $scope.details.startDate = timeZoneHackService.toClientTimezone(result.date);
      $scope.details.endDate = timeZoneHackService.toClientTimezone(result.toDate);
      $scope.details.state = result.state;
      $scope.details.allDay = result.date === result.toDate;
    }

    $scope.details.icon =
      result.icon || 'default-section-' + controller.section.toLowerCase(); // default-icon if not in backend-data
    $scope.details.bookingSection = result.bookingSection;
    $scope.details.template = false; //result.template;
    $scope.details.templateName = result.templateName;
    $scope.details.notesJson = result.notesJson;
    $scope.details.activities = result.activityName;
    $scope.details.bookingYear = result.harvestYear;

    $scope.elements = bookingRules.elementsArray(controller.section, $scope.details.icon ? $scope.details.icon : null);

    const isUserCHE = app.credentials.company.countryIsoCode === 'CHE';
    $scope.allowHarvestWithDifferentCultures = isUserCHE && result.activityName.includes('HARVESTING');

    $scope.fnMessage.key = $scope.allowHarvestWithDifferentCultures
        ? 'fe.booking.differentCultures.notAllowed' : 'fe.booking.differentCultures';
    $scope.fnMessage.type = $scope.allowHarvestWithDifferentCultures
        ? 'error' : 'warning'

    bookingRules.setAllActiveActivities(
      result.bookingSection,
      $scope.details.activities
    ); //"HARVESTING,SUPPLY"

    // we want to make sure that all of the booking elements are displayed
    // on the booking mask if they are found in the booking
    setActiveElements(result);

    //// Notes from arguments for septoria treatment
    // must be set before element.onLoad, since the notes-element needs the value
    if ($scope.details.arguments && $scope.details.arguments.isSeptoriaTreatment) {
      let notes;

      if ($scope.details.arguments.data.dateOfPrognosis) {
        let formattedDate = dateFilter($scope.details.arguments.data.dateOfPrognosis);
        notes = i18n('fe.booking.isip.septoria.notes.withDate', 'Seporia-Notes').format(formattedDate);
      } else {
        notes = i18n('fe.booking.isip.septoria.notes.withoutDate','Seporia-Notes');
      }

      // set notes to result
      // later on, in the element.onLoad, it will be loaded from here
      result.extraData = result.extraData || {};

      if (result.extraData.hasOwnProperty(notes) && result.extraData.notes !== null) {
        result.extraData.notes += ' ' + notes;
      } else {
        result.extraData.notes = notes;
      }
    }

    // Inform all elements (Field, Seed,...) to tramodel.fieldsnsform data (Fields, Seed, ...) from result
    angular.forEach(bookingRules.getActiveElements(result.bookingSection), element => {
        ang.tryUntilTrue(() => {
          if (element.onLoad) {
            element.onLoad(result);
            return true;
          } else {
            return false;
          }
        });
      }
    );

    //// Load values from arguments (e.g. for septoria treatment)
    if ($scope.details.arguments) {
      $scope.details.startDate = $scope.details.arguments.startDate;
      $scope.details.endDate = $scope.details.startDate;
      $scope.details.allDay = true;

      // add fields
      for (let i = 0; i < $scope.details.arguments.fields.length; i++) {
        let field = $scope.details.arguments.fields[i];
        $scope.addToList('field', 'asset', 'fieldList', null)(field);
      }
    }

    $timeout(() => {
      $scope.details.isLoading = false;
    }, 1000);
  };

  controller.getDataForBackend = () => {
    let activityName = bookingRules
      .getActiveActivities(controller.section)
      .map(activity => {
        return activity.name;
      })
      .join(',')
      .toUpperCase();

    // Set default-Values for BE
    let data = {
      id: $scope.details.id,
      date: $scope.details.startDate ? timeZoneHackService.toBackendTimezone($scope.details.startDate) : null,
      toDate: $scope.details.endDate ? timeZoneHackService.toBackendTimezone($scope.details.endDate) : null,
      isLastHarvest: false,
      notesJson: $scope.details.notesJson,
      state: $scope.details.state,
      template: $scope.details.template,
      templateName: $scope.details.templateName,
      bookingSection: $scope.details.bookingSection,
      activityName: activityName,
      assets: [],
      resources: [],
      products: [],
      productProportions: [],
      supplies: [],
      supplyProportions: [],
      icon: $scope.details.icon,
      allDay: $scope.details.allDay
    };

    // Inform all elements (Field, Seed,...) to transform details-data (fieldList, seedList, ...) to BE-Data (assets, products,...)
    angular.forEach(bookingRules.getActiveElements(data.bookingSection), element => {
        if (element.onSave) {
          element.onSave(data);
        }
      }
    );

    // Convert extradata back to a string as expected by backend
    if (data.extraData) {
      data.extraData = JSON.stringify(data.extraData);
    }

    return data;
  };

  controller.getCropOnField = () => {
    return $scope.cropOnFields;
  };

  controller.save = newState => {
    if(newState === 'BOOKED') {
      trackEvent('Product Interactions', 'BookingView', 'Button::Booking::Click')
    } else if(newState === 'INPLANNING') {
      trackEvent('Product Interactions', 'BookingView', 'Button::Planning::Click')
    }

    if (newState && newState !== 'TEMPLATE' && !$scope.details.validSelectedDatePeriod) {
      $rootScope.alertController.addTemporaryAlert(i18nFilter('fe.booking.operation.dateperiod.invalid'), 'error');

      return;
    }

    let data = controller.getDataForBackend();
    data.state = newState;

    // check if action is sowing and if culture was selected, otherwise block saving
    if (data.activityName.includes('SOWING') && data.state === 'BOOKED') {
      console.log('DATA ON SAVE: ', data);

      if (!data.supplies || data.supplies.length === 0) {
        $scope.dataForm.$setDirty();
        $rootScope.alertController.addTemporaryAlert(
          i18nFilter('fe.booking.operation.culture.missing'),
          'error'
        );

        return;
      }
    }

    // Ask server if this is a tilling booking that resets the crop
    return bookingService
      .checkTilling(
        data.assets,
        $scope.details.startDate,
        !controller.isActivityController() && data.state === 'BOOKED'
      )
      .then(result => {
        let askTilling = false;
        let askLastHarvest = bookingRules.isActiveActivity(controller.section, 'harvesting')
            && !controller.isActivityController() && data.state === 'BOOKED'
            && (!controller.getCropOnField() || controller.getCropOnField().canBeFinished);

          // Are we converting a booking to a planning?
        let askPlanning = isPlanning && data.state === 'BOOKED';

        // BOOKING_WITHOUT_RULES prevent popups on saving harvest
        askLastHarvest = false;   // FIXME CT 2020-06-23 Why this magic further up?

        return bookingService
          .ask('fe.booking.request.tilling.message', askTilling)
          .then(continueBooking => {
            if (continueBooking === false) {
              return;
            }

            let fieldNames = _.chain(data.assets)
              .filter(a => { return a.assetType === 'Field'; })
              .map(field => { return '"' + field.asset.name + '"'; })
              .value();

            let key, defaultValue;

            if (fieldNames.length > 1) {
              key = 'fe.booking.request.finish.harvesting.plural';
              defaultValue =
                'Have you completed the harvest in the fields {0}?<br/><br/><b>Attention:</b> If you want to harvest further types (e.g. grain or straw) in the fields, please click "No".';
            } else {
              key = 'fe.booking.request.finish.harvesting.singular';
              defaultValue =
                'Have you completed the harvest in the field {0}?<br/><br/><b>Attention:</b> If you want to harvest further types (e.g. grain or straw) in the field, please click "No".';
            }

            return bookingService
              .ask(i18nFilter(key, defaultValue, fieldNames.join(', ')), askLastHarvest)
              .then(isLastHarvest => {
                if (isLastHarvest !== undefined) {
                  data.isLastHarvest = isLastHarvest;
                }

                return bookingService
                  .ask('fe.booking.request.delplan.message', askPlanning)
                  .then(deletePlanning => {
                    if (deletePlanning) {
                      data.notesJson = (data.notesJson || '') + '|deletePlanning|';
                    }

                    app.showLoader();

                    controller.doSave(data).then(result => {
                      app.hideLoader();

                      if (result && result.success) {
                        if (data.activityName === 'SOILSAMPLE') {
                          $location.path('/booking/soilsample');
                        } else {
                          $location.path('/reporting/bookingList');
                        }
                      }
                    });
                  });
              });
          });
      });
  };

  /**
   *
   * @param data
   * @returns {ng.HttpPromise}
   */
  controller.doSave = data => {
    if (data.startDate) {
      setCookie('booking.lastStartDate', data.getTime());
    }

    let params;

    if ($scope.mode === 'EDIT') {
      // Activity-Edit
      params = {
        url: '/365FarmNet/rest/booking/operation_activities/',
        method: 'POST', // new Activity
        data: data
      };

      if ($scope.details.id) {
        // edit Activity
        params.method = 'PUT';
        params.url += $scope.details.id;
      }

      return $http(params).then(response => {
        let result = response.data;
        let isSuccessful = ang.isDefinedDeep(result, 'messagingContext.messages')
          && result.messagingContext.messages.length === 0;

        if (isSuccessful) {
          $rootScope.allowNavigation();
          $rootScope.alertController.addTemporaryAlert(i18nFilter('fe.booking.state.templateSaved'), 'success');

          // reset form and leave date as it was in the last booking
          controller.clear();
          $location.path('/booking/' + controller.section.toLowerCase());
          bookingActivitiesService.reload();
        } else {
          $rootScope.handleMsgContext(result.messagingContext);
        }
      });
    } else {
      params = {
        url: '/365FarmNet/rest/booking/operations/',
        method: 'POST',
        data: data
      };

      return $http(params)
        .then(response => {
          let result = response.data;

          if (result.success) {
            if ('FIELD' === result.updatedElement.section && !$routeParams.id) {
              bookingNavigationService.createEvent(result.updatedElement.state);
            }

            // apply septoria treatment
            if ($scope.details.arguments && $scope.details.arguments.isSeptoriaTreatment) {
              if ($scope.septoriaAlert) {
                $rootScope.alertController.closeAlert($scope.septoriaAlert);
              }

              // collect field ids and send them to IsipService
              let fieldIds = [];
              let assets;

              try {
                assets = result.object.assets;
              } catch (e) {
                // fallback if server does not send data,
                // due to a erratic bug
                assets = data.assets;
              }

              for (let i = 0; i < assets.length; i++) {
                let field = assets[i].asset;
                fieldIds.push(field.id);
              }

              $http.post('/365FarmNet/rest/isip/septoria/applyTreatment', fieldIds);
            }

            // delete arguments
            $scope.details.arguments = null;

            // reset form and leave date as it was in the last booking
            controller.clear();
            $rootScope.allowNavigation();
            $scope.details.startDate = data.startDate;
            $scope.details.endDate = data.endDate;
            $scope.details.allDay = data.allDay;
          } else {
            // $log.error('booking was not successfull');
          }

          $rootScope.handleMsgContext(result.messagingContext);

          return result;
        })
        .then(function(result) {
          // Send data to Fendt VarioDoc?
          if (controller.fendtVarioDocState.sendData && data.state === 'INPLANNING' && result.success) {
            let bookingId = result.updatedElement.id;

            return fendtVarioDocService
              .plan(bookingId)
              .then(success => {

                if (success) {
                  fendtVarioDocAlerts.showSendSuccess();

                  return markSent(bookingId).then(() => {
                    return result;
                  });
                } else {
                  fendtVarioDocAlerts.showSendFailure();
                }

                return result;
              })
              .catch(() => {
                fendtVarioDocAlerts.showSendFailure();
                return result;
              });
          } else {
            return result;
          }
        });
    }
  };

  // Jump to Core
  $scope.goBackToCore = controller.goBackToCore = (obType, id) => {
    $rootScope.allowNavigation();

    const goToPath = navigationService.getCoreRoute(obType, id); // get new `coredata-service` path
    const data = controller.getDataForBackend($scope.details);
    data.returnBookingId = null;
    let backlink = 'booking/field';

    if ($scope.details.id) {
      data.returnBookingId = $scope.details.id;
      backlink = 'booking/field/' + $scope.details.id;
    }

    let title = i18nFilter('fe.booking.back', 'zurück zur Buchung');

    if (controller.isActivityController()) {
      title = i18nFilter(
        'fe.booking.activity.back',
        'Zurück zur Eigenen Tätigkeit'
      );
      backlink = 'booking/activity';
    }

    app.gotoWithBackButton(goToPath, backlink, title, 'bookingController', {details: data});
  };

  // Come back from Core
  if ($rootScope.goBackState && !!$rootScope.goBackState.data.details
    && $route.current.params.id == $rootScope.goBackState.data.details.returnBookingId
    && $rootScope.goBackState.type == 'bookingController') {

    ang.callAfter(() => {
      // Refresh all entities
      bookingService
        .updateEntityReadOnlyFields($rootScope.goBackState.data.details)
        .then(() => {
          bookingRules.setAllActiveActivities(
            $rootScope.goBackState.data.details.bookingSection,
            $rootScope.goBackState.data.details.activities
          ); //"HARVESTING,SUPPLY"

          $rootScope.alertController.addTemporaryAlert(
            i18nFilter('fe.booking.continue.message', 'Buchung wird fortgesetzt'),
            'success');

          controller.loadByObject($rootScope.goBackState.data.details);
          $rootScope.goBackState = null; // i did go back !
        });
    }, $scope);
  }

  $scope.details.arguments = null;
  $scope.septoriaAlert = null;

  if (bookingMaskArguments.useArguments && bookingMaskArguments.activityId !== null) {
    $scope.details.arguments = bookingMaskArguments.copy();
    $scope.details.id = bookingMaskArguments.activityId;
    bookingMaskArguments.clear();

    let message = i18n('fe.booking.isip.septoria.alertMessage','Septoria-Behandlung')
      .format('#/farmmap/com.farmnet365.isip');

    $scope.septoriaAlert = $rootScope.alertController.addPageAlert(message, 'info');
  } else {
    $scope.details.id = $route.current.params.id;
  }

  let selectedFieldIds = [];

  function cropForFields() {
    //may check all are the same or mark fields als not equals
    let allCropsChain = _.chain($scope.details.fieldList).pluck('cropOnField');

    //don't react to crop changes until we finish loading the page
    let allCropsChainWithoutNulls = allCropsChain
        .filter((crop) => !_.isEmpty(crop))
        .filter((crop) => crop.sysCultureDTO !== null);

    let allSame = allCropsChainWithoutNulls
        .pluck('sysCultureDTO')
        .pluck('id')
        .unique()
        .value()
        .length <= 1;

    let cropInfo = allSame ? allCropsChainWithoutNulls.first().value() : null;
    return {allSame, cropInfo};
  }

  /**
   * Logic in case the crop on the selected fields got changed
   */
  function onCropChange(origin) {
    let {allSame, cropInfo} = cropForFields();

    // workaround, hack for CFNPOC-47515 - only if all culture in field list are the same
    if ($scope.details.state === 'PRELIMINARY' && $scope.details.icon === 'PLANTPROTECTING'
      && $scope.details.fieldList.length > 0) {

      console.log('FIELDLIST and Culture changed!', cropInfo);
      $rootScope.$broadcast('bookingmask-crop-on-fields-changed', cropInfo);
    }

    let isNewBooking = $scope.details.id === null;

    $scope.fnMessage.show = !allSame;
    disableBookingButton();

    if (!$scope.details.product) {
      $scope.details.product = {}
    }

    if (isNewBooking) {
      $scope.fetchDetailedCropInfo(cropInfo);
     }
  }

  $scope.cropOnFieldsChanged = (cultureInfo) => {
    // broadcast if selected culture is changed
    $rootScope.$broadcast('bookingmask-crop-on-fields-changed', cultureInfo);

    // dirty hack to trigger digest by watch after events were consumed by other sections ...
    $timeout(() => {
      $scope.details.fieldList.trigger = ($scope.details.fieldList.trigger) ? !$scope.details.fieldList.trigger : false;
    }, 300);
  };

  $scope.fetchDetailedCropInfo = async (cropInfo) => {
    let cropCandidate = {};

    if (cropInfo && cropInfo.sysCultureDTO){
      const response = await cultureSearchService.getSysCulture(cropInfo.sysCultureDTO.id);

      if (response.data) {
        // override with data from service reponse
        cropCandidate.harvestTypes = response.data.sysCulture_harvestTypes;
        cropCandidate.harvestTypeOptions = response.data.sysCulture_harvestTypes
          .map(function (type) {
              return type.type;
            });

        cropCandidate.harvestUnit = cropInfo.unit;

        //FIXME - what we do with inside crops
        cropCandidate.sowingType = (cropInfo.seasonDTO && cropInfo.seasonDTO.cultureDTO
          && cropInfo.seasonDTO.cultureDTO.sowingTypeEnum) ? cropInfo.seasonDTO.cultureDTO.sowingTypeEnum: 'MAIN_CROP';
        cropCandidate.sysCultureDTO = response.data.sysCulture;
      } else {
        //FIXME is this really correct or shall we use the initial setup block below instead?
        cropCandidate.sysCultureDTO = null;
        cropCandidate.harvestTypes = [];
      }
    }

    $scope.cropOnFields = cropCandidate;
    $scope.cropOnFieldsChanged($scope.cropOnFields);

    return cropCandidate;
  };

  // Workaround for CFNPOC-28538
  function setActiveElements(data) {
    // Array that will contain the sections(booking elements) that are to be displayed for this booking
    let activeElements = [];

    // Small configuration to help determine which sections contained values in the booking
    const bookingSections = [
      { source: data.assets, type: null, elementName: 'field' },
      { source: data.products, type: null, elementName: 'sysCulture' },
      {
        source: data.supplies,
        type: { key: 'supplyType', value: 'seed' },
        elementName: 'seed'
      },
      {
        source: data.supplies,
        type: { key: 'supplyType', value: 'plantprotectant' },
        elementName: 'supply'
      },
      {
        source: data.supplies,
        type: { key: 'supplyType', value: 'fertilizer' },
        elementName: 'supply'
      },
      {
        source: data.resources,
        type: { key: 'resourceType', value: 'person' },
        elementName: 'person'
      },
      {
        source: data.resources,
        type: { key: 'resourceType', value: 'machine' },
        elementName: 'machine'
      }
    ];

    bookingSections.forEach(section => {
      let containsElement = true;

      if (section.type !== null) {
        containsElement = section.source.some(
          el => el[section.type.key].toLowerCase() === section.type.value
        );
      }

      if (section.source && section.source.length > 0 && containsElement) {
        if (!activeElements.includes(section.elementName))
          activeElements.push(section.elementName);
      }
    });

    // The notes object in the booking is a little different so it was left out of the
    // bookingSections object, it is checked here for notes
    if (data.extraData && data.extraData.notes !== '') {
      activeElements.push('notes');
    }

    // Set the sections to active for the view
    activeElements.forEach(activeElement => {
      let element = $scope.elements.find(el => el.name === activeElement);
      if (element) element.active = true;
    });
  }

  function disableBookingButton() {
    let disableBooking = $scope.allowHarvestWithDifferentCultures && !cropForFields().allSame;
    controller.disabledForBooking = !controller.hasFields() || disableBooking;

    console.log("details:", $scope.details.activities);
  }

  $scope.$watch('details.fieldList.length', (newVal, oldVal) => {
    if (newVal === undefined || (newVal === undefined && oldVal === undefined)) {
      return;
    }

    if (oldVal === undefined || newVal > oldVal) {
      //if user added a new field...
      let newFieldIds = _.difference(_.pluck($scope.details.fieldList, 'feid'), selectedFieldIds);
      let newFields = _.filter($scope.details.fieldList, field => {
        return newFieldIds.indexOf(field.feid) > -1;
      });

      //field count changed - update cultures with data from harvestbookingdata service
      bookingService.fillHarvestInfo(newFields, $scope.details.startDate)
        .then(() => {
          onCropChange({changedByField:true});
        });
    } else {
      onCropChange({changedByField:true});
    }

    selectedFieldIds = _.pluck($scope.details.fieldList, 'feid');
    disableBookingButton();
    // das hier auslagern in disableForBookingButton() und ausführen von hier und wenn sich $scope.details.fieldList ändert
    controller.disabledForSaving = !controller.hasFields();
  });

  $scope.$watch('details.startDate', (newVal, oldval) => {
    if (newVal !== undefined && oldval !== undefined && newVal.getTime() !== oldval.getTime()) {
      if (newVal && $scope.details.fieldList) {
        bookingService
          .fillHarvestInfo($scope.details.fieldList, new Date(newVal))
          .then(() => {
            onCropChange({changedByDate:true});
          });
      }
    }
  });

  return ($scope.controller = this);
}
